import { useMutation } from "@shared/lib/hooks";
import { AgencyService } from "../services/agency.service";
import { ToastService } from "@shared/lib/services";
import {
  AGENCY_EMPLOYEE_LOGIN_ACCESS_QUERY_KEY,
  AGENCY_LIST_QUERY_KEY,
} from "../constants/querykeys";

export default function useAgencyEmployeeLoginAccess(agencyId: string) {
  const {
    mutate: enableLoginAccess,
    isLoading: isEnabling,
    isSuccess: isEnabled,
    isError: loginError,
    error: loginErrorMessage,
  } = useMutation<{ agencyUserId: string | undefined }>({
    mutationFn: async ({ agencyUserId }) => {
      if (agencyUserId) {
        await AgencyService.enableLoginAccess(agencyUserId);
      }
    },
    onSuccess: (c, data, variables) => {
      c.invalidateQueries({
        queryKey: [...AGENCY_LIST_QUERY_KEY, agencyId],
      });
      ToastService.success("Login access enabled");
    },

    options: {
      queryKey: [],
      skipInvalidation: false,
    },
  });

  return {
    enableLoginAccess,
    isEnabling,
    isEnabled,
    loginError,
    loginErrorMessage,
  };
}
